const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Make authenticated request with JWT token
 * @param {string} url - The API endpoint URL
 * @param {Object} options - Fetch options
 * @returns {Promise<Response>} Fetch response
 */
const makeAuthenticatedRequest = async (url, options = {}) => {
  const token = localStorage.getItem('access_token');
  
  if (!token) {
    throw new Error('No authentication token found');
  }

  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers,
    },
  });
};

// Get all contacts
export const contactsApi = {
getAllContacts: async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/v1/contacts/`);
        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching contacts:', error);
        throw new Error('Failed to fetch contacts');
    }
},

// Get contacts by account name
getContactsByAccount: async (accountName) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/v1/contacts/search/by-account/${encodeURIComponent(accountName)}`);
        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching contacts by account:', error);
        throw new Error('Failed to fetch contacts for the selected account');
    }
},

// Get contacts by account ID - keeping the old method name for backward compatibility
getContactsByCompanyId: async (accountId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/v1/contacts/search/by-account/${accountId}`);
        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching contacts by account ID:', error);
        throw new Error('Failed to fetch contacts for the selected account');
    }
},

// Get contacts by account ID
getContactsByAccountId: async (accountId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/v1/contacts/search/by-account/${accountId}`);
        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching contacts by account ID:', error);
        throw new Error('Failed to fetch contacts for the selected account');
    }
},

createContact: async (contactData) => {
    try {
        const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/v1/contacts/`, {
        method: 'POST',
        body: JSON.stringify(contactData),
        });
        
        if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating contact:', error);
        throw new Error(error.message || 'Failed to create contact');
    }
},

// Update a contact (full update)
updateContact: async (contactId, contactData) => {
try {
    const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/v1/contacts/${contactId}`, {
    method: 'PUT',
    body: JSON.stringify(contactData),
    });
    
    if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
} catch (error) {
    console.error('Error updating contact:', error);
    throw new Error(error.message || 'Failed to update contact');
}
},

// Update a contact (partial update)
patchContact: async (contactId, contactData) => {
try {
    const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/v1/contacts/${contactId}`, {
    method: 'PATCH',
    body: JSON.stringify(contactData),
    });
    
    if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
} catch (error) {
    console.error('Error updating contact:', error);
    throw new Error(error.message || 'Failed to update contact');
}
},

// Delete a contact
deleteContact: async (contactId) => {
try {
    const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/v1/contacts/${contactId}`, {
    method: 'DELETE',
    });
    
    if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return true;
} catch (error) {
    console.error('Error deleting contact:', error);
    throw new Error(error.message || 'Failed to delete contact');
}
},
};